var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column",style:({
    backgroundImage: 'url(' + require('@/assets/beon.jpg') + ')',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    height: '100vh',
    width: '100vw',
    margin: '0',
    padding: '0',
    overflow: 'hidden',
  }),attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"d-flex flex-column align-center text-center",attrs:{"cols":"12"}},[_c('v-row',{staticClass:"mt-14 my-8",attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"pr-0",attrs:{"cols":"2","justify":"center","align":"center"}},[_c('v-img',{class:{
                  'logo-class': _vm.$vuetify.breakpoint.smAndUp,
                  'logo-class-small': _vm.$vuetify.breakpoint.smAndDown,
                },attrs:{"contain":"","src":require('@/assets/VP_sin_fondo.png')}})],1),_c('v-col',{staticClass:"pl-0",attrs:{"cols":"2","justify":"center","align":"center"}},[_c('v-img',{class:{
                  'logo-class': _vm.$vuetify.breakpoint.smAndUp,
                  'logo-class-small': _vm.$vuetify.breakpoint.smAndDown,
                },attrs:{"contain":"","src":"img/beonit.png"}})],1)],1),(!_vm.isForgotPassword)?_c('v-card',{staticClass:"mt-12 mx-4 pa-6",attrs:{"width":"700"}},[_c('v-card-title',{staticClass:"justify-center mb-6"},[_c('h2',{staticClass:"error-title"},[_vm._v("Error!")])]),_c('h6',[_vm._v("The page is currently unavailable. Please, try again later.")])],1):_vm._e()],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }